"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SinglePincodeInput = exports.isStyleObject = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// keyCode constants
const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
const SPACEBAR = 32;

// Doesn't really check if it's a style Object
// Basic implementation to check if it's not a string
// of classNames and is an Object
// TODO: Better implementation
const isStyleObject = obj => typeof obj === 'object';

exports.isStyleObject = isStyleObject;

class SinglePincodeInput extends _react.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "input", void 0);

    _defineProperty(this, "getClasses", (...classes) => classes.filter(c => !isStyleObject(c) && c !== false).join(' '));
  }

  // Focus on first render
  // Only when shouldAutoFocus is true
  componentDidMount() {
    const {
      input,
      props: {
        focus,
        shouldAutoFocus
      }
    } = this;

    if (input && focus && shouldAutoFocus) {
      input.focus();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      input,
      props: {
        focus
      }
    } = this; // Check if focusedInput changed
    // Prevent calling function if input already in focus

    if (prevProps.focus !== focus && input && focus) {
      input.focus();
      input.select();
    }
  }

  render() {
    const {
      separator,
      isLastChild,
      inputStyle,
      focus,
      isDisabled,
      hasErrored,
      errorStyle,
      focusStyle,
      disabledStyle,
      isInputNum,
      value,
      onChange,
      onKeyDown,
      onInput,
      onPaste,
      onFocus,
      onBlur
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("input", {
      style: Object.assign({
        width: '1em',
        textAlign: 'center'
      }, isStyleObject(inputStyle) && inputStyle, focus && isStyleObject(focusStyle) && focusStyle, isDisabled && isStyleObject(disabledStyle) && disabledStyle, hasErrored && isStyleObject(errorStyle) && errorStyle),
      className: this.getClasses(inputStyle, focus && focusStyle, isDisabled && disabledStyle, hasErrored && errorStyle),
      type: isInputNum ? 'tel' : 'text',
      maxLength: "1",
      ref: input => {
        this.input = input;
      },
      disabled: isDisabled,
      value: value ? value : '',
      onChange: onChange,
      onKeyDown: onKeyDown,
      onInput: onInput,
      onPaste: onPaste,
      onFocus: onFocus,
      onBlur: onBlur
    }), !isLastChild && separator);
  }

}

exports.SinglePincodeInput = SinglePincodeInput;

class PincodeInput extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      activeInput: 0,
      pincode: [...Array(this.props.numInputs)].map((_, i) => "")
    });

    _defineProperty(this, "focusInput", input => {
      const {
        numInputs
      } = this.props;
      const activeInput = Math.max(Math.min(numInputs - 1, input), 0);
      this.setState({
        activeInput
      });
    });

    _defineProperty(this, "focusNextInput", () => {
      const {
        activeInput
      } = this.state;
      this.focusInput(activeInput + 1);
    });

    _defineProperty(this, "focusPrevInput", () => {
      const {
        activeInput
      } = this.state;
      this.focusInput(activeInput - 1);
    });

    _defineProperty(this, "handleOnPaste", e => {
      e.preventDefault();
      const {
        numInputs,
        isInputNum,
        onChange
      } = this.props;
      let hasString = false; // Get pastedData in an array of max size (num of inputs - current position)

      const pastedData = e.clipboardData.getData('text/plain').split('').slice(0, numInputs); //Prevent to insert string, when isInputNum is true

      pastedData.forEach(value => {
        if (isInputNum && isNaN(Number(value))) hasString = true;
      });
      if (isInputNum && hasString) return false;
      onChange(pastedData);
      this.setState({
        pincode: pastedData
      });
      this.focusInput(numInputs - 1);
    });

    _defineProperty(this, "handleOnChange", e => {
      const {
        activeInput,
        pincode
      } = this.state;
      const {
        isInputNum,
        onChange
      } = this.props;
      const newPiconde = pincode;

      if (isInputNum && isNaN(Number(e.target.value))) {
        this.focusInput(activeInput);
        return false;
      } // fix backspace on android chrome


      if (e.target.value.length === 0 || e.target.value == " ") {
        return false;
      }

      newPiconde[activeInput] = e.target.value;
      this.setState({
        pincode: newPiconde
      });
      this.focusNextInput();
      onChange(pincode);
    });

    _defineProperty(this, "handleOnKeyDown", e => {
      const {
        pincode,
        activeInput
      } = this.state;
      const {
        onChange
      } = this.props;
      const newPiconde = pincode;

      if ((e.keyCode === BACKSPACE || e.key === 'Backspace') && e.target.value.length === 0) {
        e.preventDefault();
        this.focusPrevInput();
      } else if (e.keyCode === BACKSPACE || e.key === 'Backspace') {
        e.preventDefault();
        newPiconde[activeInput] = '';
        this.setState({
          pincode: newPiconde
        });
        onChange(pincode);
      } else if (e.keyCode === DELETE || e.key === 'Delete') {
        e.preventDefault();
        newPiconde[activeInput] = '';
        this.setState({
          pincode: newPiconde
        });
        onChange(pincode);
      } else if (e.keyCode === LEFT_ARROW || e.key === 'ArrowLeft') {
        e.preventDefault();
        this.focusPrevInput();
      } else if (e.keyCode === RIGHT_ARROW || e.key === 'ArrowRight') {
        e.preventDefault();
        this.focusNextInput();
      } else if (e.keyCode === SPACEBAR || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
      } // Workaround on Android browser
      // Input on Android: 229 Unidentified 
      else if (e.key === 'Unidentified') {
          e.preventDefault();
          newPiconde[activeInput] = '';
          this.setState({
            pincode: newPiconde
          });
          onChange(pincode);
        }
    });

    _defineProperty(this, "checkLength", e => {
      const value = e.target.value.trim();

      if (value.length > 1) {
        e.preventDefault();
        this.focusNextInput();
      }
    });

    _defineProperty(this, "renderInputs", () => {
      const {
        activeInput,
        pincode
      } = this.state;
      const {
        numInputs,
        inputStyle,
        focusStyle,
        separator,
        isDisabled,
        disabledStyle,
        hasErrored,
        errorStyle,
        shouldAutoFocus,
        isInputNum,
        clear
      } = this.props;
      const inputs = [];

      for (let i = 0; i < numInputs; i++) {
        inputs.push( /*#__PURE__*/_react.default.createElement(SinglePincodeInput, {
          key: i,
          focus: activeInput === i,
          value: clear ? '' : pincode[i],
          onChange: this.handleOnChange,
          onKeyDown: this.handleOnKeyDown,
          onInput: this.checkLength,
          onPaste: this.handleOnPaste,
          onFocus: e => {
            this.setState({
              activeInput: i
            });
            e.target.select();
          },
          onBlur: () => this.setState({
            activeInput: -1
          }),
          separator: separator,
          inputStyle: inputStyle,
          focusStyle: focusStyle,
          isLastChild: i === numInputs - 1,
          isDisabled: isDisabled,
          disabledStyle: disabledStyle,
          hasErrored: hasErrored,
          errorStyle: errorStyle,
          shouldAutoFocus: shouldAutoFocus,
          isInputNum: isInputNum
        }));
      }

      return inputs;
    });
  }

  componentDidMount() {
    const {
      initialValue
    } = this.props;

    if (initialValue) {
      this.setState({
        pincode: initialValue
      });
    }
  }

  componentWillReceiveProps() {
    const {
      clear,
      numInputs
    } = this.props;

    if (clear) {
      this.setState({
        pincode: [...Array(numInputs.numInputs)].map((_, i) => "")
      });
    }
  } // Focus on input by index


  render() {
    const {
      containerStyle
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: Object.assign({
        display: 'flex'
      }, isStyleObject(containerStyle) && containerStyle),
      className: !isStyleObject(containerStyle) ? containerStyle : ''
    }, this.renderInputs());
  }

}

_defineProperty(PincodeInput, "defaultProps", {
  numInputs: 4,
  onChange: callback => callback(PincodeInput.state.pincode),
  isDisabled: false,
  shouldAutoFocus: false,
  clear: false
});

var _default = PincodeInput;
exports.default = _default;